export const processLocationQuery = (search: string): { [key: string]: string } => {
  return decodeURI(search)
    .replace('?', '')
    .split('&')
    .reduce(
      (p, c) => {
        const [key, value] = c.split('=');
        p[key] = value;

        return p;
      },
      {} as { [key: string]: string }
    );
};
